import initialstate from '../initialstate';
import {normalize} from '../../util/utils';
import * as types from '../../actions/actiontypes';
import {HttpStatusCodes} from '../../util/uiconstants';

export default function documenttypesreducer(state = initialstate.documentTypes, action) {
	switch (action.type) {
		case types.GET_ALL_DOCUMENT_TYPES: {
			if (action.response && action.responseObj.status === HttpStatusCodes.Ok) {
				return normalize(action.response, 'documentTypeId', state);
			}
			return state;
		}
		default: {
			return state;
		}
	}
}
